module.exports = __webpack_public_path__ + "static/media/yafa_2.442d1d37.jpg";